import * as Yup from 'yup';

export default Yup.object().shape({
  invoiceNumber: Yup.string()
    .trim()
    .required('Required'),
  invoiceDate: Yup.date().required('Required')
});
